import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DialogUploadComponent } from './dialog-upload.component';


const routes: Routes = [
  {
    path: '',
    component: DialogUploadComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DialogUploadRoutingModule { }
